;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:offsoo-landing":true});}catch(e){}}();const requireEnv = (name: string, value: string | undefined) => {
  if (!value) {
    throw new Error(`Missing ${name} environment variable`)
  }
  return value
}

export const siteUrl = requireEnv('NEXT_PUBLIC_SITE_URL', process.env.NEXT_PUBLIC_SITE_URL)
export const calendlyUrl = requireEnv('NEXT_PUBLIC_CALENDLY_URL', process.env.NEXT_PUBLIC_CALENDLY_URL)
export const intercomAppId = requireEnv('NEXT_PUBLIC_INTERCOM_APP_ID', process.env.NEXT_PUBLIC_INTERCOM_APP_ID)
export const recaptchaSiteKey = requireEnv('NEXT_PUBLIC_RECAPTCHA_SITE_KEY', process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY)
export const pusherAppKey = requireEnv('NEXT_PUBLIC_PUSHER_APP_KEY', process.env.NEXT_PUBLIC_PUSHER_APP_KEY)
export const pusherAppCluster = requireEnv('NEXT_PUBLIC_PUSHER_APP_CLUSTER', process.env.NEXT_PUBLIC_PUSHER_APP_CLUSTER)
export const appDomain = requireEnv('NEXT_PUBLIC_APP_DOMAIN', process.env.NEXT_PUBLIC_APP_DOMAIN)

/**
 * The score-based ("invisible") reCAPTCHA Enterprise key for the sign-up email step. Optional:
 * unset means the step keeps the checkbox it always had. Set it only after the Manager verifies
 * `captchaKind: 'score'` against its own copy of this key (ADR-0014).
 */
export const recaptchaScoreSiteKey = process.env.NEXT_PUBLIC_RECAPTCHA_SCORE_SITE_KEY?.trim() || undefined
